// Ported from mobile_ce/lib/utils/mapping_utilities.dart so the portal's
// geofence math matches the mobile app's radius/polygon behavior exactly.

export const FEET_PER_METER = 3.280839895;

export function feetToMeters(feet) {
  return feet / FEET_PER_METER;
}

export function metersToFeet(meters) {
  return meters * FEET_PER_METER;
}

export function getPolygonCenter(points) {
  const latSum = points.reduce((sum, p) => sum + p.lat, 0);
  const lngSum = points.reduce((sum, p) => sum + p.lng, 0);
  return { lat: latSum / points.length, lng: lngSum / points.length };
}

function degreesToRadians(degrees) {
  return (degrees * Math.PI) / 180;
}

function haversineDistanceMeters(p1, p2) {
  const earthRadius = 6371000;
  const lat1 = degreesToRadians(p1.lat);
  const lon1 = degreesToRadians(p1.lng);
  const lat2 = degreesToRadians(p2.lat);
  const lon2 = degreesToRadians(p2.lng);

  const dLat = lat2 - lat1;
  const dLon = lon2 - lon1;

  const a =
    Math.pow(Math.sin(dLat / 2), 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(dLon / 2), 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return earthRadius * c;
}

export function getPolygonRadiusInMeters(points) {
  if (!points || points.length === 0) return 0;
  const center = getPolygonCenter(points);
  return points.reduce(
    (max, p) => Math.max(max, haversineDistanceMeters(center, p)),
    0
  );
}

function onSegment(px, py, qx, qy, rx, ry) {
  return (
    qx <= Math.max(px, rx) &&
    qx >= Math.min(px, rx) &&
    qy <= Math.max(py, ry) &&
    qy >= Math.min(py, ry)
  );
}

function orientation(px, py, qx, qy, rx, ry) {
  const val = (qy - py) * (rx - qx) - (qx - px) * (ry - qy);
  if (val === 0) return 0;
  return val > 0 ? 1 : 2;
}

function segmentsIntersect(p1, p2, p3, p4) {
  const o1 = orientation(p1.lat, p1.lng, p2.lat, p2.lng, p3.lat, p3.lng);
  const o2 = orientation(p1.lat, p1.lng, p2.lat, p2.lng, p4.lat, p4.lng);
  const o3 = orientation(p3.lat, p3.lng, p4.lat, p4.lng, p1.lat, p1.lng);
  const o4 = orientation(p3.lat, p3.lng, p4.lat, p4.lng, p2.lat, p2.lng);

  if (o1 !== o2 && o3 !== o4) return true;
  if (o1 === 0 && onSegment(p1.lat, p1.lng, p3.lat, p3.lng, p2.lat, p2.lng))
    return true;
  if (o2 === 0 && onSegment(p1.lat, p1.lng, p4.lat, p4.lng, p2.lat, p2.lng))
    return true;
  if (o3 === 0 && onSegment(p3.lat, p3.lng, p1.lat, p1.lng, p4.lat, p4.lng))
    return true;
  if (o4 === 0 && onSegment(p3.lat, p3.lng, p2.lat, p2.lng, p4.lat, p4.lng))
    return true;
  return false;
}

export function isPolygonSimple(points) {
  if (!points || points.length < 3) return false;
  const n = points.length;
  for (let i = 0; i < n; i++) {
    for (let j = i + 2; j < n; j++) {
      if (j === n - 1 && i === 0) continue;
      if (
        segmentsIntersect(
          points[i],
          points[(i + 1) % n],
          points[j],
          points[(j + 1) % n]
        )
      ) {
        return false;
      }
    }
  }
  return true;
}
